import React, { memo } from 'react'
import PropTypes from 'prop-types'

import CompositionsModal from '@eig-builder/compositions-modal'

const Modal = ({ actions, children, dataElementPrefix, handleClose, maxWidth, ModalProps, open, title, disableBackdropClick }) => {
  return <CompositionsModal
    actions={actions}
    dataElementPrefix={dataElementPrefix}
    disableBackdropClick={disableBackdropClick}
    height='auto'
    maxWidth={maxWidth}
    ModalProps={ModalProps}
    open={open}
    onClose={handleClose}
    title={title}
    withContentBorder
  >
    {children}
  </CompositionsModal>
}

Modal.propTypes = {
  actions: PropTypes.array,
  children: PropTypes.node.isRequired,
  dataElementPrefix: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  maxWidth: PropTypes.string,
  ModalProps: PropTypes.object,
  open: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  disableBackdropClick: PropTypes.bool.isRequired
}

Modal.defaultProps = {
  disableBackdropClick: true
}

export default memo(Modal)
